import React from 'react';
import styled from 'styled-components';
import byLeanloopImg from './by-leanloop.svg';

const StyledA = styled.a`
  padding: ${({ theme }) => theme.spacingBase};
`;

export default function ByLeanloop() {
  return (
    <StyledA href="https://www.leanloop.co.uk">
      <img src={byLeanloopImg} alt="By Leanloop" />
    </StyledA>
  );
}
